import { BASE_API } from '../../utils/constantes'
import { getToken } from '../Common/token'

const BASE_FACTURAS = `${BASE_API}/api-facturas`

const jsonHeaders = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${getToken()}`
})

/**
 * Manda el archivo ya subido a la IA y devuelve los datos extraidos sin guardarlos.
 * Cuando el analisis falla el backend igual responde 200 con estado_analisis "error"
 * y datos en null, para que el modal se abra y se cargue a mano.
 */
export async function analizarFactura({ urlArchivo, tipoCarga, documentoId = null }) {
    try {
        const url = `${BASE_FACTURAS}/analizar/`
        const params = {
            method: "POST",
            headers: jsonHeaders(),
            body: JSON.stringify({
                url_archivo: urlArchivo,
                tipo_carga: tipoCarga,
                documento_id: documentoId
            })
        }
        const response = await fetch(url, params)

        if (response.status !== 200) {
            throw new Error(`Error al analizar la factura: ${response.status}`)
        }

        return await response.json()
    } catch (error) {
        console.error("Error en analizarFactura:", error)
        throw error
    }
}

const construirQuery = (origen, filtros = {}) => {
    const query = new URLSearchParams({ origen })

    Object.entries(filtros).forEach(([clave, valor]) => {
        if (valor !== null && valor !== undefined && valor !== "") {
            query.append(clave, valor)
        }
    })

    return query.toString()
}

export async function getFacturas(origen, filtros = {}) {
    try {
        const url = `${BASE_FACTURAS}/facturas/?${construirQuery(origen, filtros)}`
        const params = {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        }
        const response = await fetch(url, params)

        if (response.status !== 200) {
            throw new Error(`Error al obtener las facturas: ${response.status}`)
        }

        return await response.json()
    } catch (error) {
        console.error("Error en getFacturas:", error)
        throw error
    }
}

/**
 * Pide el Excel del listado con los mismos filtros. El backend lo genera en segundo
 * plano y devuelve un hash que se sigue con /api/check-report/ (ver NotificationContext).
 */
export async function getReporteFacturas(origen, filtros = {}) {
    try {
        const url = `${BASE_FACTURAS}/facturas/reporte/?${construirQuery(origen, filtros)}`
        const params = {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        }
        const response = await fetch(url, params)

        if (response.status !== 200) {
            throw new Error(`Error al generar el reporte: ${response.status}`)
        }

        return await response.json()
    } catch (error) {
        console.error("Error en getReporteFacturas:", error)
        throw error
    }
}

export async function createFactura(request) {
    try {
        const url = `${BASE_FACTURAS}/facturas/`
        const params = {
            method: "POST",
            headers: jsonHeaders(),
            body: JSON.stringify(request)
        }
        const response = await fetch(url, params)

        if (response.status !== 200 && response.status !== 201) {
            throw new Error(`Error al crear la factura: ${response.status}`)
        }

        return await response.json()
    } catch (error) {
        console.error("Error en createFactura:", error)
        throw error
    }
}

export async function updateFactura(id, request) {
    try {
        const url = `${BASE_FACTURAS}/facturas/${id}/`
        const params = {
            method: "PUT",
            headers: jsonHeaders(),
            body: JSON.stringify(request)
        }
        const response = await fetch(url, params)

        if (response.status !== 200) {
            throw new Error(`Error al actualizar la factura: ${response.status}`)
        }

        return await response.json()
    } catch (error) {
        console.error("Error en updateFactura:", error)
        throw error
    }
}

export async function deleteFactura(id) {
    try {
        const url = `${BASE_FACTURAS}/facturas/${id}/`
        const params = {
            method: "DELETE",
            headers: jsonHeaders()
        }
        const response = await fetch(url, params)

        if (response.status !== 204) {
            throw new Error(`Error al eliminar la factura: ${response.status}`)
        }

        return { status: "success" }
    } catch (error) {
        console.error("Error en deleteFactura:", error)
        throw error
    }
}
